import { Node_Type } from "./../../ricos-types";
import {
  CollapsibleListItemBodyProperty,
  CollapsibleListItemTitleProperty
} from "./collapsibleItemProperty";
import CollapsibleList from "./collapsibleList";
import CollapsibleListItem from "./collapsibleListItem";
const nodeViewRenderers = {
  [Node_Type.COLLAPSIBLE_LIST]: CollapsibleList,
  [Node_Type.COLLAPSIBLE_ITEM]: CollapsibleListItem,
  [Node_Type.COLLAPSIBLE_ITEM_TITLE]: CollapsibleListItemTitleProperty,
  [Node_Type.COLLAPSIBLE_ITEM_BODY]: CollapsibleListItemBodyProperty
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
